import { ExpiredPasswordSchema } from 'schemas/ExpiredPassword'
export { auth as baseURL } from 'constants/apiBaseUrls'

export const Schema = ExpiredPasswordSchema

export const url = () => '/v1/password/update'

export const getBody = ({ oldPassword, password }) => ({ oldPassword, password })
